import { render, staticRenderFns } from "./kkyz.vue?vue&type=template&id=658f633c&scoped=true&"
import script from "./kkyz.vue?vue&type=script&lang=js&"
export * from "./kkyz.vue?vue&type=script&lang=js&"
import style0 from "./kkyz.vue?vue&type=style&index=0&id=658f633c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f633c",
  null
  
)

export default component.exports